var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LinkedIn",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.074,
    height: 43.074,
    viewBox: "0 0 43.074 43.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M0,21.537A21.537,21.537,0,0,1,21.537,0h0A21.537,21.537,0,0,1,43.074,21.537h0A21.537,21.537,0,0,1,21.537,43.074h0A21.537,21.537,0,0,1,0,21.537Z",
    fill: "#0a66c2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M30.942,9H10.749A1.749,1.749,0,0,0,9,10.749V30.942a1.749,1.749,0,0,0,1.749,1.749H30.942a1.749,1.749,0,0,0,1.749-1.749V10.749A1.749,1.749,0,0,0,30.942,9ZM16.061,29.182H12.5V17.868h3.562ZM14.278,16.3a2.045,2.045,0,1,1,2.056-2.043A2.015,2.015,0,0,1,14.278,16.3ZM29.19,29.191H25.63V23.011c0-1.823-.775-2.386-1.775-2.386a2.167,2.167,0,0,0-2.093,2.432v6.135H18.2V17.876h3.425v1.568h.046a3.887,3.887,0,0,1,3.386-1.885c1.987,0,4.134,1.18,4.134,4.635Z",
    transform: "translate(0.692 0.692)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.82be1b74f1af8aeae15a85300cb82f5f.svg";
export { ForwardRef as ReactComponent };